export default __webpack_public_path__ + "/img/001-sk-banner-mob.0404b5da.jpg";